import {designSystemToken} from '@lightricks/react-design-system';
import {CSSObject} from '@mui/material';

// Helper functions to create scrollbar styles

const createScrollbarStyles = (): CSSObject => ({
  // Cross-browser scrollbar support
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: designSystemToken('semantic.bg.tertiary'),
    borderRadius: '50px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: designSystemToken('semantic.fg.tertiary'),
    borderRadius: '50px',
  },
  'scrollbarWidth': 'thin',
  'scrollbarColor': `${designSystemToken(
    'semantic.fg.tertiary'
  )} ${designSystemToken('semantic.bg.tertiary')}`,
  'WebkitOverflowScrolling': 'touch',
});

const createScrollbarHoverStyles = (): CSSObject => ({
  // Cross-browser scrollbar support
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'transparent',
  },
  'scrollbarWidth': 'thin',
  'scrollbarColor': 'transparent transparent', // Firefox - initially transparent
  'WebkitOverflowScrolling': 'touch',
  '&:hover': {
    '&::-webkit-scrollbar-track': {
      background: designSystemToken('semantic.bg.tertiary'),
      borderRadius: '50px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: designSystemToken('semantic.fg.tertiary'),
      borderRadius: '50px',
    },
    // Firefox hover styles
    'scrollbarColor': `${designSystemToken(
      'semantic.fg.tertiary'
    )} ${designSystemToken('semantic.bg.tertiary')}`,
  },
});

const createScrollbarHiddenStyles = (): CSSObject => ({
  // Cross-browser scrollbar hiding
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  'scrollbarWidth': 'none',
  'msOverflowStyle': 'none',
  'WebkitOverflowScrolling': 'touch',
});

// Export scrollbar mixins
// eslint-disable-next-line import/prefer-default-export
export const scrollbarMixins = {
  overrideScrollbar: createScrollbarStyles,
  overrideScrollbarHover: createScrollbarHoverStyles,
  overrideScrollbarHidden: createScrollbarHiddenStyles,
};

// Example usage:
/*
import {Box, styled} from '@mui/material';
import {scrollbarMixins} from '@/styles/mixins';

const ScrollableContainer = styled(Box)`
  height: 300px;
  overflow-y: auto;
  
  ${scrollbarMixins.overrideScrollbar}
`;

const HoverScrollableContainer = styled(Box)`
  height: 300px;
  overflow-y: auto;
  
  ${scrollbarMixins.overrideScrollbarHover}
`;

const HiddenScrollableContainer = styled(Box)`
  height: 300px;
  overflow-y: auto;
  
  ${scrollbarMixins.overrideScrollbarHidden}
`;

// Or use with sx prop:
<Box
  sx={{
    height: 300,
    overflowY: 'auto',
    ...scrollbarMixins.overrideScrollbar,
  }}
>
  Content here
</Box>
*/
